// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface ICommunicationCategoriesInfoDto
 */
export interface ICommunicationCategoriesInfoDto {
    /**
     * 
     * @type {Set<string>}
     * @memberof ICommunicationCategoriesInfoDto
     */
    communication_category_types: Set<ICommunicationCategoriesInfoDtoCommunicationCategoryTypesEnum>;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof ICommunicationCategoriesInfoDto
     */
    communication_category_types_state?: IFieldStateType;
}

/**
* @export
* @enum {string}
*/
export enum ICommunicationCategoriesInfoDtoCommunicationCategoryTypesEnum {
    WELCOME = 'WELCOME',
    ENROLLMENT_UPDATES = 'ENROLLMENT_UPDATES',
    HSA = 'HSA',
    INVESTMENTS = 'INVESTMENTS',
    REMINDERS = 'REMINDERS',
    CAMPAIGNS = 'CAMPAIGNS',
    CARD_STATUS = 'CARD_STATUS',
    PROFILE_UPDATES = 'PROFILE_UPDATES',
    ACCOUNT_ACTIVITY = 'ACCOUNT_ACTIVITY',
    ENROLLMENTS = 'ENROLLMENTS',
    INVOICE = 'INVOICE',
    TAX_FORMS = 'TAX_FORMS',
    FINANCE = 'FINANCE'
}


/**
 * Check if a given object implements the ICommunicationCategoriesInfoDto interface.
 */
export function instanceOfICommunicationCategoriesInfoDto(value: object): value is ICommunicationCategoriesInfoDto {
    if (!('communication_category_types' in value) || value['communication_category_types'] === undefined) return false;
    return true;
}

export function ICommunicationCategoriesInfoDtoFromJSON(json: any): ICommunicationCategoriesInfoDto {
    return ICommunicationCategoriesInfoDtoFromJSONTyped(json, false);
}

export function ICommunicationCategoriesInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICommunicationCategoriesInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'communication_category_types': new Set(json['communication_category_types']),
        'communication_category_types_state': json['communication_category_types_state'] == null ? undefined : IFieldStateTypeFromJSON(json['communication_category_types_state']),
    };
}

export function ICommunicationCategoriesInfoDtoToJSON(json: any): ICommunicationCategoriesInfoDto {
    return ICommunicationCategoriesInfoDtoToJSONTyped(json, false);
}

export function ICommunicationCategoriesInfoDtoToJSONTyped(value?: ICommunicationCategoriesInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'communication_category_types': Array.from(value['communication_category_types'] as Set<any>),
        'communication_category_types_state': IFieldStateTypeToJSON(value['communication_category_types_state']),
    };
}

